import { Dispatch } from "react";
import { BREADCRUMBS_TYPES, BreadcrumbsAction } from "./types";
import * as H from "history";


/**
 * Add breadcrumb to stack
 * @function
 * @async
 *
 * @param location
 */
export const addBreadcrumb = (location: H.Location) => async (dispatch: Dispatch<BreadcrumbsAction>) => {
  try {
    dispatch({
      type: BREADCRUMBS_TYPES.COMPLETED,
      payload: location,
    });
  } catch (err) {
    console.error(err);
  }
};